// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"f638961c","384":"ab682646","453":"ce041d04"}[chunkId] + ".chunk.js";
};